import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

interface FormSectionProps {
  children: ReactNode;
  title: string;
  titleAdornment?: ReactNode;
}

export const FormSection = ({
  title,
  titleAdornment,
  children,
}: FormSectionProps) => (
  <section className="bg-primary border-primary flex w-full flex-col gap-6 rounded-2xl border p-6">
    <div className="flex items-center gap-1">
      <Typography variant="label-md" component="h3">
        {title}
      </Typography>
      {titleAdornment}
    </div>
    {children}
  </section>
);
